import { type Enum } from '@webapp/infrastructure/types/Enum'

export const IntegrationLocalEntities = {
  VENDOR: 'urn:integration:local-entity:vendor',
  BILL: 'urn:integration:local-entity:bill',
  PAYMENT: 'urn:integration:local-entity:payment',
  PURCHASE_ORDER_ITEM: 'urn:integration:local-entity:purchaseorderitem',
  BILL_ITEM: 'urn:integration:local-entity:billitem',
  PURCHASE_ORDER: 'urn:integration:local-entity:purchaseorder',
  TENANT: 'urn:integration:local-entity:tenant',
  CURRENCY: 'urn:integration:local-entity:currency',
  TAX: 'urn:integration:local-entity:tax',
  ACCOUNT_CODE: 'urn:integration:local-entity:accountcode',
  PAYMENT_ITEM: 'urn:integration:local-entity:paymentitem',
  NULL: 'urn:integration:local-entity:null',
  REPORT_FIELD: 'urn:integration:local-entity:reportfield',
  BILL_ATTACHMENT: 'urn:integration:local-entity:billattachment',
  REFERENCE_BILL: 'urn:integration:local-entity:referencebill',
  TRANSACTION: 'urn:integration:local-entity:transaction',
  ATTACHMENT: 'urn:integration:local-entity:attachment',
} as const

export type IntegrationLocalEntityEnum = Enum<typeof IntegrationLocalEntities>
